<script>
import AdminPanel from '@components/admin-panel/admin-panel.vue';
import BillingSummaryBlock from '@components/checkout/billing-summary-block.vue';
import PaymentHistoryBlock from '@components/checkout/payment-history-block.vue';
import ClientForm from '@components/forms/client-form.vue';
import {
  trainerComputed,
  trainerMethods,
  authMethods,
  adminPanelComputed,
  adminPanelMethods,
  clientComputed,
  clientMethods,
  authComputed,
  organizationComputed,
} from '@state/helpers';
import ProductAccountDetails from '@components/checkout/product-account-details.vue';
import { adminPanelMixin } from '@mixins/admin-panel-mixin';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';

export default {
  page: {
    title: 'Client Subcription',
    meta: [{ name: 'description', content: `The Client's Subscription page.` }],
  },
  components: {
    AdminPanel,
    BillingSummaryBlock,
    PaymentHistoryBlock,
    ProductAccountDetails,
    ClientForm,
  },
  mixins: [adminPanelMixin],
  props: {
    client: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data: function() {
    return {
      clientPlan: true,
      isFree: false,
      enablingFree: false,
    };
  },
  mounted() {
    if (
      !this.isSmartPayUser &&
      this.$refs &&
      this.$refs.inputToggleInput &&
      this.client &&
      this.client.profile &&
      has(this.client.profile, 'subscribed')
    ) {
      this.$refs.inputToggleInput.checked = this.client.profile.subscribed;
      this.isFree = this.client.profile.subscribed;
    } else {
      if (!this.isSmartPayUser) {
        this.$refs.inputToggleInput.checked = false;
        this.isFree = false;
      }
    }
  },
  computed: {
    ...adminPanelComputed,
    ...trainerComputed,
    ...clientComputed,
    ...authComputed,
    ...organizationComputed,
    isSmartPayUser() {
      return (
        (this.computedClient &&
          this.computedClient.profile &&
          has(this.computedClient.profile, 'subscribed') &&
          has(this.computedClient.profile, 'subscribed_plan') &&
          this.computedClient.profile.subscribed_plan) ||
        (this.computedClient &&
          this.computedClient.invitation &&
          has(this.computedClient.invitation, 'price_plan') &&
          this.computedClient.invitation.price_plan)
      );
    },
    isInvited() {
      return (
        !isEmpty(this.computedClient.invitation.sent_at) ||
        !isEmpty(this.computedClient.invitation.reSent_at)
      );
    },
    isRegistered() {
      return (
        this.computedClient.profile.lastSeen ||
        this.computedClient.profile.last_seen ||
        (has(this.computedClient.profile, 'successfulSignup') &&
          this.computedClient.profile.successfulSignup)
      );
    },
    subscriptionDetails() {
      return this.computedClient &&
        this.computedClient.billing &&
        this.computedClient.billing.subscriptions &&
        this.computedClient.billing.subscriptions.length > 0 &&
        this.computedClient.billing.subscriptions[0] &&
        this.computedClient.billing.subscriptions[0].plan
        ? this.computedClient.billing.subscriptions[0].plan
        : {};
    },
    oneTimeDetails() {
      return this.computedClient &&
        this.computedClient.billing &&
        this.computedClient.billing.invoices &&
        this.computedClient.billing.invoices.length > 0 &&
        this.computedClient.billing.invoices[0].lines &&
        this.computedClient.billing.invoices[0].lines.data &&
        this.computedClient.billing.invoices[0].lines.data[0] &&
        this.computedClient.billing.invoices[0].lines.data[0].price
        ? this.computedClient.billing.invoices[0].lines.data[0].price
        : {};
    },
    charges() {
      return (
        this.computedClient &&
        this.computedClient.billing &&
        this.computedClient.billing.charges
      );
    },
    computedClient() {
      return this.selectedClient;
    },
  },
  methods: {
    ...adminPanelMethods,
    ...trainerMethods,
    ...authMethods,
    ...clientMethods,
    async showAdminPanel(component, data = null, size = '') {
      await this.setPanelContent(this.getPanelContent(component, data, size));
      this.setShowAdminPanel();
    },
    // TODO: enable when api ready
    // viewStripeDashboard() {
    //   console.log(this.currentUser);
    //   if (this.currentUser.roles && this.currentUser.roles.isTrainer) {
    //     // const trainer = this.currentUser.trainer;
    //     // const trainerStripeUrl = trainer
    //     // window.open(trainerStripeUrl)
    //   }
    // },
    toggled(e) {
      this.isFree = e.target.checked;
      this.enablingFree = true;
      const client = this.client;

      const updatePayload = {
        ...client,
        profile: { ...client.profile, subscribed: this.isFree },
      };

      // const invitePayload = {
      //   client_id: client._id,
      //   trainer_id: client.trainer_id,
      // };
      delete updatePayload.hasUnreadMessages;

      this.updateClient({ clientObj: updatePayload })
        .then(async (res) => {
          try {
            if (res.client) {
              // if (!this.isInvited && !this.isRegistered && this.isFree) {
              //   await this.inviteClient({ inviteObj: invitePayload });
              // }
              const updatedClient = await this.getClient({
                clientObj: res.client,
              });
              await this.setUpdateClientItem(updatedClient);
              await this.setSelectedClient(updatedClient);
              this.enablingFree = false;
            }
          } catch (e) {
            console.log(e);
          }
          this.enablingFree = false;
        })
        .catch((e) => console.log(e));
    },
  },
  watch: {
    async isAdminPanelActive(val) {
      if (!val) {
        await this.setSelectedProduct(null);
        await this.setPanelContent(null);
      }
    },
  },
};
</script>

<template>
  <div>
    <AdminPanel
      :title="panelContent ? panelContent.title : ''"
      :size="panelContent ? panelContent.size : ''"
    >
      <component
        v-if="panelContent && isAdminPanelActive"
        :is="panelContent.component"
        :content="panelContent"
        :isInvited="isInvited"
        :isRegistered="isRegistered"
        :client="computedClient"
      />
    </AdminPanel>
    <div class="full">
      <div v-if="isSmartPayUser">
        <!-- TODO: enable when api ready -->
        <!-- <div class="row">
          <div class="main-cta col-4 ml-auto">
            <BaseButton
              type="button"
              class="btn-secondary btn-round"
              @click="viewStripeDashboard"
            >
              View Billing Dashboard
            </BaseButton>
          </div>
        </div> -->
        <div class="content-container row">
          <div class="col">
            <div class="summary-block-col col">
              <BillingSummaryBlock
                :client="computedClient"
                :subscriptionDetails="subscriptionDetails"
                :oneTimeDetails="oneTimeDetails"
              />
            </div>
            <div class="col">
              <div class="payment-block-container">
                <span class="title">Payment History</span>
                <PaymentHistoryBlock
                  :client="computedClient"
                  :charges="charges"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="!isSmartPayUser">
        <div class="main-cta col-4 ml-auto">
          <div class="row app-access">
            <div class="col-10">
              <div class="row title">
                App Access
              </div>
              <div class="row description">
                {{
                  `${
                    isFree
                      ? 'Revoke access to ' + organizationTitle + ' TRAIN'
                      : 'Give your client access to ' +
                        organizationTitle +
                        ' TRAIN'
                  }`
                }}
              </div>
            </div>
            <div class="col">
              <div class="custom-control custom-switch">
                <input
                  :disabled="enablingFree"
                  ref="inputToggleInput"
                  type="checkbox"
                  class="custom-control-input"
                  id="customSwitches"
                  :value="
                    client && client.profile && client.profile.subscribed
                      ? client.profile.subscribed
                      : false
                  "
                  @input="toggled"
                />
                <label
                  ref="inputToggleLabel"
                  :class="[
                    'custom-control-label',
                    { isFree: isFree, disabled: enablingFree },
                  ]"
                  for="customSwitches"
                />
              </div>
            </div>
            <BaseIcon
              v-if="enablingFree"
              name="sync"
              class="enablingFree"
              spin
            />
          </div>
        </div>
      </div>
      <div class="no-smart-pay-content" v-if="!isSmartPayUser">
        <div>
          <p class="modal-text-main"
            >{{
              computedClient &&
              computedClient.profile &&
              computedClient.profile.firstName
                ? computedClient.profile.firstName
                : 'This Client'
            }}
            is not using {{ organizationTitle }} PAY</p
          >
          <p class="modal-text-second"
            >Starting using {{ organizationTitle }} PAY?</p
          >
          <p class="modal-text-third"
            >Transition your client to {{ organizationTitle }} PAY, the simplest
            way to collect payment and train your clients. If you aren’t ready
            to make the jump, you can manage App Access manually.</p
          >
          <div class="actions">
            <BaseButton
              class="btn-primary btn-round"
              @click="showAdminPanel('ProductAccountDetails', null, 'md')"
            >
              Signup for {{ organizationTitle }} PAY
            </BaseButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.title {
  color: $color-black-one;
  font-size: 18px;
  font-style: normal;
  font-weight: bold;
  letter-spacing: -0.466667px;
  line-height: 32px;
  margin-bottom: 2rem;
}

.main-cta {
  align-items: flex-end;
  display: flex;
  justify-content: flex-end;

  .app-access {
    background: $color-white;
    border: 1px solid $color-light-gray-twelve;
    border-radius: 12px;
    box-sizing: border-box;
    max-width: 38rem;
    min-width: 38rem;
    padding: 1rem;
    padding-left: 2rem;
    padding-right: 2rem;
    width: 100%;

    .enablingFree {
      bottom: 15%;
      color: $color-action;
      height: 1.2rem;
      position: absolute;
      right: 3%;
      width: 1.2rem;
    }

    .col-10 {
      flex: 0 0 70.333333%;
      max-width: 70.333333%;
      .title {
        font-size: 16px;
        font-weight: 800;
        line-height: 22px;
        margin-bottom: unset;
      }
      .description {
        color: $color-dark-gray-one;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        letter-spacing: 0.116667px;
        line-height: 19px;
      }
    }

    .col {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-right: unset;
    }
    .custom-control {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      height: 3.5rem;
      outline: 0 !important;
      -webkit-user-select: none; /* Chrome/Safari */
      -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* IE10+ */

      /* Rules below not implemented in browsers yet */
      -o-user-select: none;
      user-select: none;
      width: 6.5rem;
    }
    .custom-control-input {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      border: unset;
      outline: 0 !important;
      width: 6.5rem !important;
    }
    .custom-control-label {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      border: unset;
      cursor: pointer;
      font-size: 3rem;
      outline: 0 !important;
      &:focus {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        border: unset;
        border-color: unset !important;
        outline: 0 !important;
      }
      &::before {
        align-self: center;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-color: rgba($color-light-gray-alt-wo-rgb, 0.5) !important;
        border: unset;
        border-color: unset !important;
        border-radius: 3.5rem;
        box-shadow: inset 0 4px 4px rgba($color-black-wo-rgb, 0.06);
        height: 3.5rem !important;
        justify-self: center;
        outline: 0 !important;
        width: 6.5rem !important;
      }
      &::after {
        align-self: center;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        background-color: $color-action !important;
        border-radius: 3.5rem;
        height: calc(3.5rem - 2px);
        justify-self: center;
        left: calc(-2.25rem + 1px);
        outline: 0 !important;
        top: calc(0.25rem + 1px);
        width: calc(3.5rem - 2px);
      }
      &.disabled {
        cursor: unset;
        &::after {
          background-color: gray !important;
        }
      }
      &.isFree {
        &::before {
          background: rgba($color-primary-one-wo-rgb, 0.22) !important;
          box-shadow: inset 0 4px 4px rgba($color-black-wo-rgb, 0.06);
        }
        &::after {
          left: calc(-0.25rem + 3px);
        }
      }
    }
  }
}

.payment-block-container {
  margin-top: 3rem;
}

::v-deep .full {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-start;
  margin-top: 3rem;
  width: 100%;
}

::v-deep .panel-overlay {
  background-color: transparent !important;
}

.summary-block-col {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.no-smart-pay-content {
  background: $color-white;
  border-radius: 12px !important;
  box-shadow: 0 4px 8px rgba($color-black-wo-rgb, 0.08);
  margin-left: auto;
  margin-right: auto;
  margin-top: 25vh;
  max-width: 62%;
  min-width: 42%;
  padding-bottom: 1%;
  padding-left: 3rem;
  padding-right: 3rem;
  padding-top: 2%;
  .modal-text-main {
    @include calc-font-size(2);

    color: $color-black-one;
    font-style: normal;
    font-weight: 900;
    letter-spacing: -0.233333px;
    line-height: 28px;
    margin-left: 3rem;
    margin-right: 3rem;
    margin-top: 2rem;
    text-align: center;
  }
  .modal-text-second {
    color: $color-black-one;
    font-size: 18px;
    font-weight: 800;
    letter-spacing: -0.233333px;
    opacity: 0.5;
    text-align: center;
  }
  .modal-text-third {
    color: $color-black-one;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: -0.233333px;
    text-align: center;
  }
  .actions {
    display: flex;
    justify-content: space-around;
    padding-bottom: 2rem;
    padding-top: 2rem;
    .button {
      align-items: center;
      display: flex;
      height: 4rem;
      justify-content: center;
    }
    svg {
      margin-right: 1rem;
      path {
        fill: white;
      }
    }
  }
  .error {
    color: red;
  }
}
</style>
